import { render, staticRenderFns } from "./notebook.vue?vue&type=template&id=5d1fe6b2&scoped=true&"
import script from "./notebook.vue?vue&type=script&lang=js&"
export * from "./notebook.vue?vue&type=script&lang=js&"
import style0 from "./notebook.vue?vue&type=style&index=0&id=5d1fe6b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fe6b2",
  null
  
)

export default component.exports